import { z } from "zod/v4";

export const tokenSchema = z.object({
  token: z.string().min(1),
});

export const newPasswordSchema = z
  .object({
    newPassword: z.string().min(8, "密碼長度至少為 8 個字元"),
    confirmPassword: z.string().min(1, "請再一次輸入確認密碼"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "密碼不相符",
    path: ["confirmPassword"],
  });
